export default __webpack_public_path__ + "static/buderus-1-d4b47b6024daf08d27039911cb23fafe.jpg";